export default
class UserCanceledDialogError extends Error {
  constructor(dialogName) {
    super(`User canceled: ${dialogName}`)
    this.name = `UserCanceledDialogError:${dialogName}`
  }
}
